import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Theme from "@amzn/meridian/esm/components/theme";
import waveformImage from "../../images/summary_progress.svg";
import { CONTENT_MAX_WIDTH, WAVEFORM_ICON_TOKENS } from "./waveformLayout.constants";
import { waveformClass } from "./waveformLayout.styles";

/**
 * WaveformLayout - layout for every status screen: a waveform image centered on top, and the
 * content column indented under it.
 *
 * @param {string} [image] - status image; defaults to the plain waveform. Pass one with the icon
 *   already drawn in (start / stopped) and leave `icon` empty.
 * @param {node} [icon] - drawn in a white circle overlapping the bottom of the waveform
 *   (loader, warning, error). A medium Loader renders at 48px.
 */
const WaveformLayout = ({ image = waveformImage, icon, children }) => (
  <Column spacing="450" spacingInset="600 none none none">
    <Row alignmentHorizontal="center">
      <div className={waveformClass}>
        <img src={image} alt="" />
        {icon && <div><Theme tokens={WAVEFORM_ICON_TOKENS}>{icon}</Theme></div>}
      </div>
    </Row>
    {/* With an icon, start below the half of the circle that hangs under the image */}
    <Column
      spacing="450"
      spacingInset={icon ? "500 none none 600" : "none none none 600"}
      alignmentHorizontal="start"
      maxWidth={CONTENT_MAX_WIDTH}
    >
      {children}
    </Column>
  </Column>
);

export default WaveformLayout;
